var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"disabled":_vm.disabled,"content":_vm.title,"placement":"top","effect":"light"}},[_c('span',{ref:"span",staticClass:"textOverflow"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }